module.exports = __webpack_public_path__ + "img/header-engagementRingsBudgetLow.3e01b5b.webp";